const A = "primary", R = "secondary", E = "success", _ = "danger", n = "warning", o = "info", s = "light", I = "dark", c = "link", t = "xs", T = "sm", N = "md", L = "lg", S = "xl", O = "xxl", M = 0, r = 576, G = 768, P = 992, V = 1200, K = 1600, l = "FormControl", e = "FormSelect";
export {
  V as BREAKPOINT_EXTRA_LARGE,
  K as BREAKPOINT_EXTRA_LARGE_2,
  M as BREAKPOINT_EXTRA_SMALL,
  P as BREAKPOINT_LARGE,
  G as BREAKPOINT_MEDIUM,
  r as BREAKPOINT_SMALL,
  l as FORM_TYPE_CONTROL,
  e as FORM_TYPE_SELECT,
  S as SIZE_EXTRA_LARGE,
  O as SIZE_EXTRA_LARGE_2,
  t as SIZE_EXTRA_SMALL,
  L as SIZE_LARGE,
  N as SIZE_MEDIUM,
  T as SIZE_SMALL,
  _ as VARIANT_DANGER,
  I as VARIANT_DARK,
  o as VARIANT_INFO,
  s as VARIANT_LIGHT,
  c as VARIANT_LINK,
  A as VARIANT_PRIMARY,
  R as VARIANT_SECONDARY,
  E as VARIANT_SUCCESS,
  n as VARIANT_WARNING
};
